/**
 * 月度税务申报（增值税/个税/个税汇总）生成与人工推送
 */
import request from '@/utils/request'

// ==================== 增值税申报 ====================

// 增值税申报列表
export function vatList(query) {
  return request({
    url: `/ntocc-basic-api/tax/monthlyVat/list`,
    method: 'get',
    params: query
  })
}

// 增值税申报按申报月份重新生成
export function vatRegenerate(declarationMonth) {
  return request({
    url: `/ntocc-basic-api/tax/monthlyVat/regenerate`,
    method: 'put',
    params: { declarationMonth }
  })
}

// 增值税申报单条推送
export function vatPush(id) {
  return request({
    url: `/ntocc-basic-api/tax/monthlyVat/push/${id}`,
    method: 'put'
  })
}

// 增值税申报批量推送
export function vatPushBatch(ids) {
  return request({
    url: `/ntocc-basic-api/tax/monthlyVat/pushBatch`,
    method: 'put',
    params: { ids }
  })
}

// ==================== 个税申报 ====================

// 个税申报列表
export function personalList(query) {
  return request({
    url: `/ntocc-basic-api/tax/monthlyPersonal/list`,
    method: 'get',
    params: query
  })
}

// 个税申报按申报月份重新生成
export function personalRegenerate(declarationMonth) {
  return request({
    url: `/ntocc-basic-api/tax/monthlyPersonal/regenerate`,
    method: 'put',
    params: { declarationMonth }
  })
}

// 个税申报单条推送
export function personalPush(id) {
  return request({
    url: `/ntocc-basic-api/tax/monthlyPersonal/push/${id}`,
    method: 'put'
  })
}

// 个税申报批量推送
export function personalPushBatch(ids) {
  return request({
    url: `/ntocc-basic-api/tax/monthlyPersonal/pushBatch`,
    method: 'put',
    params: { ids }
  })
}

// ==================== 个税汇总 ====================

// 个税汇总列表
export function summaryList(query) {
  return request({
    url: `/ntocc-basic-api/tax/monthlySummary/list`,
    method: 'get',
    params: query
  })
}

// 个税汇总按申报月份重新生成
export function summaryRegenerate(declarationMonth) {
  return request({
    url: `/ntocc-basic-api/tax/monthlySummary/regenerate`,
    method: 'put',
    params: { declarationMonth }
  })
}

// 个税汇总逐条推送
export function summaryPush(id) {
  return request({
    url: `/ntocc-basic-api/tax/monthlySummary/push/${id}`,
    method: 'put'
  })
}
